import { render } from "./heatTreatmentInquire.vue?vue&type=template&id=fa2eb19c&scoped=true"
import script from "./heatTreatmentInquire.vue?vue&type=script&lang=js"
export * from "./heatTreatmentInquire.vue?vue&type=script&lang=js"

import "./heatTreatmentInquire.vue?vue&type=style&index=0&id=fa2eb19c&scoped=true&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa2eb19c"]])

export default __exports__